import { isRejectedWithValue } from "@reduxjs/toolkit";
import type { MiddlewareAPI, Middleware } from "@reduxjs/toolkit";
import { setMessage } from "@store/snackbarSlice";
import i18n from "i18next";
import { setOpen } from "@store/offlineBannerSlice";
import { SignOutService } from "@service/sign-out.service";

let isUnauthorizedSignOutInProgress = false;

export const apiErrorHandler: Middleware =
  (api: MiddlewareAPI) => (next) => async (action) => {
    const typedAction = action as any;
    const responseStatus =
      typedAction?.meta?.baseQueryMeta?.response?.status ??
      typedAction?.payload?.status;

    if (isRejectedWithValue(action) && responseStatus === 401) {
      const hasAuthenticatedUser = !!api.getState()?.auth?.user;

      if (hasAuthenticatedUser && !isUnauthorizedSignOutInProgress) {
        isUnauthorizedSignOutInProgress = true;
        try {
          await SignOutService.instance.signOut(api.dispatch);
        } finally {
          isUnauthorizedSignOutInProgress = false;
        }
      }
      return next(action);
    }
    if (
      isRejectedWithValue(action) &&
      typedAction?.meta?.baseQueryMeta?.request?.method === "GET"
    ) {
      if (
        typedAction?.payload?.status === "FETCH_ERROR" &&
        api.getState()?.auth?.user
      ) {
        api.dispatch(setOpen(true));
      } else {
        api.dispatch(
          setMessage({
            content: i18n.t("errors.unknown"),
            severity: "error",
          }),
        );
      }
    }

    return next(action);
  };
